import { registerComponent } from "helpers";
import SearchspringComponent from "searchspring";

registerComponent(
  "results-pagination",
  class ResultsPagination extends SearchspringComponent {
    constructor() {
      super();

      this.pageInput = this.SearchPage.querySelector('input[name="page"]');

      this.paginationTemplate = this.querySelector(
        '[data-template="pagination"]',
      );
      this.itemTemplate = this.querySelector('[data-template="item"]');
    }

    render({ pagination }) {
      if (!pagination || pagination.totalPages <= 1) {
        return;
      }

      this.renderPagination(pagination);
    }

    renderPagination(data) {
      const pagination = this.paginationTemplate.content.cloneNode(true);
      const list = pagination.querySelector('[data-template-element="list"]');

      const pagesToShow = this.calculatePagesToShow(
        data.currentPage,
        data.totalPages,
      );

      const paginationItems = [
        { type: "firstPage", page: 1 },
        { type: "previousPage", page: data.previousPage },
        ...pagesToShow.map((page) => ({ type: "page", page })),
        { type: "nextPage", page: data.nextPage },
        { type: "lastPage", page: data.totalPages },
      ];

      paginationItems.forEach(({ type, page }) => {
        const itemTemplate = this.itemTemplate.content.cloneNode(true);
        const item = itemTemplate.querySelector(
          '[data-template-element="item"]',
        );

        const classList = [];
        let textContent = "";
        let ariaLabel = "";
        let node = null;

        switch (type) {
          case "firstPage":
            textContent = "«";
            ariaLabel = WYATT.t.pagination.firstPage;
            classList.push("pagination__item--first");

            break;
          case "lastPage":
            textContent = "»";
            ariaLabel = WYATT.t.pagination.lastPage;
            classList.push("pagination__item--last");

            break;
          case "previousPage":
            textContent = "‹";
            ariaLabel = WYATT.t.pagination.previousPage;
            classList.push("pagination__item--previous");

            break;
          case "nextPage":
            textContent = "›";
            ariaLabel = WYATT.t.pagination.nextPage;
            classList.push("pagination__item--next");

            break;
          default:
            textContent = page;
            ariaLabel = `${WYATT.t.pagination.page} ${page}`;

            if (page === data.currentPage) {
              classList.push("pagination__item--current");
            }

            break;
        }

        if (page === data.currentPage || page === 0) {
          item.classList.add("pagination__item--current");
          node = document.createElement("span");
          node.setAttribute("aria-current", "page");
        } else {
          node = document.createElement("a");
          node.href = this.getHref(page);
          node.addEventListener("click", this.handleClick.bind(this, page));
        }

        node.setAttribute("aria-label", ariaLabel);
        node.textContent = textContent;
        node.classList.add("pagination__node");

        item.appendChild(node);
        item.classList.add(...classList);

        list.appendChild(item);
      });

      this.appendChild(pagination);
    }

    calculatePagesToShow(currentPage, totalPages) {
      const maxPages = 5;
      const pages = [];

      if (totalPages <= maxPages) {
        // If total pages is 5 or less, show all pages
        for (let i = 1; i <= totalPages; i += 1) {
          pages.push(i);
        }
      } else {
        // Calculate the range of pages to show
        let startPage = Math.max(1, currentPage - 2);
        let endPage = Math.min(totalPages, currentPage + 2);

        // Adjust if we're near the beginning
        if (currentPage <= 3) {
          startPage = 1;
          endPage = Math.min(maxPages, totalPages);
        }
        // Adjust if we're near the end
        else if (currentPage >= totalPages - 2) {
          startPage = Math.max(1, totalPages - maxPages + 1);
          endPage = totalPages;
        }

        // Generate the page numbers
        for (let i = startPage; i <= endPage; i += 1) {
          pages.push(i);
        }
      }

      return pages;
    }

    getHref(page) {
      const params = this.SearchPage.formParams;

      params.set("page", page);

      return `${window.location.pathname}?${params.toString()}`;
    }

    handleClick(page, event) {
      event.preventDefault();

      this.pageInput.value = page;

      this.SearchPage.useUrlParams = false;
      this.SearchPage.fetchResults();

      this.scrollToTop();
    }
  },
);
